// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"1ffe1bf36148598a","6831":"760e24b8c4b7064d","8503":"aec91fd94060b928","9683":"f3ecbed2efd870ec"}[chunkId] + ".js";
};